import { render, staticRenderFns } from "./vue-qr.vue?vue&type=template&id=675eacf7&"
import script from "./vue-qr.vue?vue&type=script&lang=js&"
export * from "./vue-qr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports